<template>
<!-- <div> -->
<div class="main-body">
  <div class="main-body-search" >

    <el-form :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item>
      <el-select v-model="filters.type" placeholder="机构类别" change="">
          <el-option
           v-for="item in residentOfficeTypes"
           :key="item.key"
           :label="item.value"
           :value="item.key">
          </el-option>
        </el-select>
       </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="创建时间起" style="width: 100%;" value-format="yyyy-MM-dd 00:00:00" v-model="filters.createTimeStart"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="创建时间止" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59" v-model="filters.createTimeEnd"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filters.residentofficeName" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  type="primary" @click="searchMain(1)" >查询</el-button>
      </el-form-item>
      <!-- <el-tooltip v-if="apiAuth('orglog.orgLog.insert')" :content="$t('c.table.tip.createNewRecord')" placement="top">
        <el-button v-show="actionValueAsComp < 3" size="small" type="primary" icon="el-icon-document-add" @click="openDialog(ACTION.NEW)">{{ $t('c.table.new') }}</el-button>
      </el-tooltip> -->
    </el-form>
  </div>
  <div class="main-body-table">
    <el-table :data="mainTableData" @row-dblclick="rowDblclick" @selection-change="handleSelectionChange">
      <!-- <el-table-column
        type="selection"
        width="30">
      </el-table-column> -->
      <el-table-column
        prop="residentofficeName"
        :label="$t('m.orgLog.residentofficeName')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        nin-width="350"
        prop="description"
        :label="$t('m.orgLog.description')"
        align="center"
      >
      </el-table-column>

      <!-- <el-table-column
        prop="objectName"
        :label="$t('m.orgLog.objectName')"
        align="center"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.objectName">{{ dictUtils.getObjectNameValue(scope.row.objectName) }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="operateTypeDictValue"
        :label="$t('m.orgLog.operateType')"
        align="center"
        >
      </el-table-column> -->

      <el-table-column
        prop="createDate"
        :label="$t('m.orgLog.createDate')"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="createUser"
        :label="$t('m.orgLog.createUser')"
        align="center"
        >
      </el-table-column>
      <!-- <el-table-column
        prop="isManagerDictValue"
        :label="$t('m.orgLog.isManager')"
        align="center"
      >
      </el-table-column> -->

    </el-table>
    <!--分页工具条-->
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :current-page="pager.current" :page-size="pager.size" :total="total">
    </el-pagination>

  </div>
  <comp-org-log
    v-if="detailDialogVisible"
    :actionOfParent="currentAction"
    :currentTableRow="currentTableRow"
    :detailDialogVisible.sync="detailDialogVisible"
    @listenToDetailDialogClose="detailDialogCloseWithModified"
    :operateTypeDicts="operateTypeDicts"
    :isManagerDicts="isManagerDicts"
  >
  </comp-org-log>
</div>
<!-- </div> -->
</template>

<script>
import {
    selectBriefEdition,
} from '@/views/yourbiz/api/sum/Org';
import {
  selectPageOrgLog,
  deleteByIdOrgLog,
  deleteBatchIdsOrgLog
} from '../../api/org/OrgLog';
import CompOrgLog from '../../comp/org/CompOrgLog';
import dateUtil from '../../../common/js/util';
export default {
  name: 'orglogOrgLog',
  props: {
    // 外键约束属性
    // 来自父组件指定的标题
    cardTitle: String,
    // 来自父组件的操作类型参数
    actionOfParent: Object
  },
  components: {
    CompOrgLog
  },
  data() {
    return {
      residentOfficeTypes: [],
      // 查询条件
      filters: {
        type: this.utils.orgCategories[0].key,
        createTimeStart: dateUtil.formatDate((new Date(new Date()-1000*60*60*24*90)), 'yyyy-MM-dd 23:59:59', 0), //创建时间起
        createTimeEnd: dateUtil.formatDate((new Date()), 'yyyy-MM-dd 23:59:59', 0) //创建时间止
      },
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10,
        fuzzyText: ''
      },
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 当前主表行记录
      currentTableRow: {},
      // 当前主表中选中的行记录
      selectedRows: [],
      // 主表数据
      mainTableData: [],
      // 作为组件时的操作类型, 根据父组件变动, 默认为2:编辑
      actionValueAsComp: 2,
      // 当前组件是否已经有服务端更新
      modified: false,
      // 对话框显示隐藏控制
      detailDialogVisible: false,
      // 机构简略信息
      briefEdition: [],
    };
  },
  computed: {
    // 字典数据列表: 操作类型, 放在computed中确保i18n可用
    operateTypeDicts: function () {
      return [ { itemCode: 'create', value: '创建'}, { itemCode: 'modify', value: '修改' }, { itemCode: 'remove', value: '删除' }, { itemCode: 'cancel', value: '注销' }, { itemCode: 'recovery', value: '恢复' }, { itemCode: 'submit', value: '提交' }, { itemCode: 'sendBack', value: '退回' }, { itemCode: 'getThrough', value: '通过' }, { itemCode: 'print', value: '打印' }, { itemCode: 'reclaim', value: '回收证件' }, { itemCode: 'upload', value: '上传' }, { itemCode: 'download', value: '下载' } ];
    },
    // 字典数据列表: 是否为管理员操作, 放在computed中确保i18n可用
    isManagerDicts: function () {
      return [ { itemCode: 'yes', value: '是'}, { itemCode: 'no', value: '否' } ];
    },
    // 操作类型常量
    ACTION: function () {
      return {
        NEW: { value: 1, name: this.$t('c.table.new') },
        EDIT: { value: 2, name: this.$t('c.table.edit') },
        VIEW: { value: 3, name: this.$t('c.table.view') }
      }
    }
  },
  // 页面首次加载数据
  mounted() {
    //this.findBriefEdition();
    if (this.actionOfParent) {
      this.actionValueAsComp = this.actionOfParent.value;
    }
    // 默认取 - 获取当前用户可使用的机构类型第一个值
    this.filters.type = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))[0].key
    // 获取当前用户可使用的机构类型
    this.residentOfficeTypes = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))

    this.searchMain(1);
  },
  methods: {
    // // 构简略信息查询
    // findBriefEdition() {
    //   selectBriefEdition(
    //     // {"orgType":this.filters.type,
    //     //  "isRegister":"yes"
    //     // }
    //   ).then(result => {
    //     if(result.code == 20000 && result.data) {
    //       this.briefEdition = result.data;
    //     }
    //   })
    // },
    /**
     * 点击列标题排序
     * @param column 点击排序的列对象
     */
    sortChange: function(column) {
      this.pager.prop = column.prop;
      this.pager.order = column.order;
      if (column.prop === 'operateTypeDictValue') {
        this.pager.prop = 'operateType';
      }
      if (column.prop === 'isManagerDictValue') {
        this.pager.prop = 'isManager';
      }
      this.searchMain(1);
    },
    /**
     * 主表勾选记录事件
     * @param {Array} rows 当前选中的记录列表
     */
    handleSelectionChange: function(rows) {
      this.selectedRows = rows;
    },
    /**
     * 更新成功后的关闭对话框事件
     * @param {ACTION} action 操作类型
     */
    detailDialogCloseWithModified: function(action) {
      if (action.value === 1) {
        // NEW
        this.searchMain(1);
      } else if (action.value === 2) {
        // EDIT
        this.searchMain();
      }
      this.$emit('listenToCompModifiedEvent');
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size;
      this.searchMain();
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current;
      this.searchMain();
    },
    /**
     * 分页主表查询
     * @param current int 可选参数，查询指定页的数据
     * current: 不传值或传null/undefined/0，表示翻页
     * current: 大于等于1表示重新查询该页
     *    例如：更新某记录后重新加载当前页
     *    例如：删除某记录、查询文本框回车、查询按钮点击则传1，重新查询第1页
     */
    searchMain(first) {
      // if (current && current >= 1) {
      //   // 重新查询该页
      //   this.pager.current = current;
      // }
      if (first === 1) {
        this.filters.current = 1
        this.filters.size = 10
      } else {
        this.filters.current = this.pager.current; //当前页数
        this.filters.size = this.pager.size;
      }
      this.fetchMainTable();
    },
    /**
     * 分页查询主表数据, 参数fuzzyText支持模糊查询
     */
    fetchMainTable() {
      if (!this.apiAuth('orglog.orgLog.selectPage')) {
        // 无查询权限
        return;
      }
      // this.filters.current = this.pager.current;
      // this.filters.size = this.pager.size;
      // this.filters.fuzzyText = this.pager.fuzzyText;
      console.log(this.filters);
      selectPageOrgLog(this.filters).then(result => {
        this.total = result.total;
        this.mainTableData = result.data;
        this.setDictValueColumn();
      });
    },
    /**
     * 设置主表数据集合中字典itemCode列的字典值列
     */
    setDictValueColumn() {
      if (this.mainTableData && this.mainTableData.length > 0) {
        this.mainTableData.forEach(row => {
          row.operateTypeDictValue = this.findDictItemValueByItemCode(row.operateType, this.operateTypeDicts);
          row.isManagerDictValue = this.findDictItemValueByItemCode(row.isManager, this.isManagerDicts);
        });
        // 使数组的更新被VUE检测到
        this.mainTableData.push({});
        this.mainTableData.pop();
      }
    },
    /**
     * 删除该行记录
     * @param row 行记录对象
     * @param index 行索引号
     */
    deleteRow(row) {
      this.$confirm(this.$t('c.table.deleteRowConfirm'), this.$t('c.tips'), {
        type: 'warning'
      })
        .then(() => {
          deleteByIdOrgLog({ id: row.id }).then(result => {
            if (result.code === 20000) {
              this.$emit('listenToCompModifiedEvent');
              this.searchMain(1);
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 批量删除记录
     */
    deleteBatch() {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'warning',
          message: this.$t('c.table.pleaseSelectForDelete')
        });
        return;
      }
      this.$confirm(
        this.$t('c.table.deleteBatchConfirm1') + this.selectedRows.length + this.$t('c.table.deleteBatchConfirm2'),
        this.$t('c.tips'),
        { type: 'warning' }
      )
        .then(() => {
          deleteBatchIdsOrgLog({ lsIds: this.selectedRows.map(row => row.id) }).then(result => {
            if (result.code === 20000) {
              this.$emit('listenToCompModifiedEvent');
              this.searchMain(1);
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 表格行双击事件打开查看对话框
     * @param row 双击的行记录对象
     * @param event 鼠标事件
     * @param column 双击的列对象
     */
    rowDblclick(row) {
      this.openDialog(this.ACTION.VIEW, row)
    },
    /**
     * 打开对话框
     * @param action ACTION.NEW/ACTION.EDIT/ACTION.VIEW
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    async openDialog(action, row) {
      this.currentTableRow = Object.assign({}, row || this.getDefaultFormModel());
      this.currentAction = action;
      this.detailDialogVisible = true;
    },
    /**
     * 根据itemCode从字典项列表dicts查找对应记录的value并返回
     * @param itemCode 字典项编码，数值（仅限单值）或者是字符串（多值以逗号分隔）
     * @param dicts 字典项列表
     * @returns 字典value，多个以逗号分隔
     */
    findDictItemValueByItemCode(itemCode, dicts) {
      if (itemCode === undefined || itemCode === null || itemCode === '') {
        return '';
      }
      if (!isNaN(itemCode)) {
        // itemCode是数值
        return dicts.filter(item => itemCode === item.itemCode)[0].value;
      }
      // itemCode是字符串
      let codes = itemCode.split(',');
      let items = dicts.filter(item => {
        return codes.some(code => {
          return code === item.itemCode;
        });
      });
      return items.map(item => item.value).join(';');
    },
    /**
     * 设置新增对话框表单中的默认值
     * @returns 默认值对象
     */
    getDefaultFormModel() {
      return {
        // postId: this.postIdDicts[0].itemCode,
        // orgId: this.orgIdOptions[0].id,
        // 使用数组为多选控件(例如checkbox, 可多选的select)赋默认值, 值为字典项的itemCode或实体的id.
        // color: ['red', 'black']
        deleteMe: '请删除该行，仅用于占末位'
      };
    }
  }
};
</script>

<style lang="scss"></style>
